/**
 * P-1.6: which of the four rows a chat is in. Chatwoot's status is the only truth: `pending`
 * means the assistant owns it and `open` means a person does. The channel's A6 state decides
 * only whether a pending chat is really being answered.
 */

/** The label a handover puts on a chat (the sidecar's `handover.ts` `NEEDS_A_PERSON_LABEL`). */
export const NEEDS_A_PERSON_LABEL = 'needs-a-person';

export const CHAT_ROWS = Object.freeze({
  ANSWERING: 'answering',
  PERSON: 'person',
  BLOCKED: 'blocked',
  CLOSED: 'closed',
});

/**
 * Channel states in which a pending chat is answered. `practice` counts: a practising
 * assistant's pending chats are its testers' (every other chat is opened for the team by the
 * practice handover). An unknown state (the status read failed) counts too, because a pending
 * chat IS the assistant's by Chatwoot's own status.
 */
const ANSWERED = new Set(['answering', 'practice']);

export const canGiveBack = channelState =>
  channelState === null ||
  channelState === undefined ||
  ANSWERED.has(channelState);

/** `answering` | `person` | `blocked` | `closed`, or null when the chat is not known. */
export const chatRow = ({ chatStatus, channelState }) => {
  if (chatStatus === 'resolved') return CHAT_ROWS.CLOSED;
  if (chatStatus === 'open' || chatStatus === 'snoozed')
    return CHAT_ROWS.PERSON;
  if (chatStatus === 'pending') {
    return canGiveBack(channelState) ? CHAT_ROWS.ANSWERING : CHAT_ROWS.BLOCKED;
  }
  return null;
};
